// extracted by mini-css-extract-plugin
module.exports = {"face_modal_wrap":"FaceModal_face_modal_wrap__MJmY5","icon":"FaceModal_icon__276Ni","rotateIcon":"FaceModal_rotateIcon__MgLmd","description":"FaceModal_description__Spky6"};